module.exports = __webpack_public_path__ + "static/media/ubuntu.0e98e978.jpg";